import { RtCommonApiRoutes } from 'RtExports/routes';
import {
	RateSheetGeneratorIndexResponse,
	RateSheetGeneratorProfileResponse
} from 'RtModels';
import { AccountManagementRouter } from 'RtUi/app/AccountManagement/AccountManagement.router';
import { IProfileApplicationContainerTabs } from 'RtUi/components/containers/TabbedApplicationContainer';
import { TabbedLayoutTabProps } from 'RtUi/components/ui/TabbedLayout';

interface IRateSheetGeneratorRouterTabs
	extends IProfileApplicationContainerTabs {
	Profile: TabbedLayoutTabProps;
}

export const RateSheetGeneratorContainerTabs: IRateSheetGeneratorRouterTabs = {
	Profile: {
		header: 'Profile'
	}
};

export class RateSheetGeneratorRouterClass extends AccountManagementRouter<
	RateSheetGeneratorIndexResponse,
	RateSheetGeneratorProfileResponse,
	IRateSheetGeneratorRouterTabs
> {
	constructor() {
		super(
			'Rate Generation',
			'rateSheetGenerator',
			'rateSheetGeneratorId',
			RateSheetGeneratorContainerTabs
		);

		this.setPermissionsFromApiRoute(RtCommonApiRoutes.RateSheetGenerator);
	}

	public getProfileLabel(profile: RateSheetGeneratorProfileResponse) {
		return profile.label;
	}

	public getPluralName() {
		return this.getName();
	}
}

export const RateSheetGeneratorRouter = new RateSheetGeneratorRouterClass();
